import { getDayOfTheWeekByDate } from 'components/common/DaypartTargeting/utils';
import { GroupOfSelectedDays } from 'components/common/types/Deal.types';
import { DirectSalesLine } from 'components/common/types/DirectSalesCampaign.types';
import { addDays, compareAsc, differenceInDays } from 'date-fns';

export const updateDatesForDirectSalesLines = (
  lines: Partial<DirectSalesLine>[],
  newCampaignStartDate: Date,
): Partial<DirectSalesLine>[] => {
  newCampaignStartDate.setHours(0, 0, 0, 0);

  const earliestLineStartDate = lines
    .map((line) => new Date(line.startDate ?? ''))
    .sort((dateA: Date, dateB: Date) => compareAsc(dateA, dateB))[0];

  return lines.map((line) => {
    const { startDate, endDate, selectedDays } = line;
    const lineStartDate = new Date(startDate ?? '');
    const lineEndDate = new Date(endDate ?? '');

    const newLineStartDate = addDays(newCampaignStartDate, differenceInDays(lineStartDate, earliestLineStartDate));
    const newLineEndDate = addDays(newLineStartDate, differenceInDays(lineEndDate, lineStartDate));

    const newSelectedDays: GroupOfSelectedDays = Object.entries(selectedDays ?? {}).reduce((acc, [key, day]) => {
      const newDayDate = addDays(newCampaignStartDate, differenceInDays(day.date, earliestLineStartDate));
      acc[key] = {
        ...day,
        date: newDayDate,
        dayOfTheWeek: getDayOfTheWeekByDate(newDayDate),
      };
      return acc;
    }, {} as GroupOfSelectedDays);

    return { ...line, startDate: newLineStartDate, endDate: newLineEndDate, selectedDays: newSelectedDays };
  });
};
